import axios from 'axios';
import { getUser } from '@/api/gateway';
import { config } from '@/api/workflow';
import { listProducts } from '@/api/workflow';

export default {
  state: () => ({
    preloading: true,
    loading: false,
    token: null,
    user: null,
    products: [],
    selectedAccountId: parseInt(localStorage.getItem('a-eye-selected-account-id') || '0')
  }),
  mutations: {
    preloadUserStatusPending(state) {
      state.preloading = true;
    },
    preloadUserStatusSuccess(state, { user }) {
      state.preloading = false;
      state.user = user;
      if (user && user.accounts && user.accounts.length && !user.accounts.find(a => a.id === state.selectedAccountId)) {
        state.selectedAccountId = 0;
      }
      if (user && user.accounts && user.accounts.length && !state.selectedAccountId) {
        state.selectedAccountId = user.accounts[0].id;
        localStorage.setItem('a-eye-selected-account-id', state.selectedAccountId);
      }
    },
    preloadUserStatusFailure(state) {
      state.preloading = false;
    },
    fetchUserStatusPending(state) {
      state.loading = true;
    },
    fetchUserProductsSuccess(state, { products }) {
      state.products = products;
    },
    fetchUserStatusSuccess(state, { user }) {
      state.loading = false;
      state.user = user;
      if (user && user.accounts && user.accounts.length && !user.accounts.find(a => a.id === state.selectedAccountId)) {
        state.selectedAccountId = 0;
      }
      if (user && user.accounts && user.accounts.length && !state.selectedAccountId) {
        state.selectedAccountId = user.accounts[0].id;
        localStorage.setItem('a-eye-selected-account-id', state.selectedAccountId);
      }
    },
    fetchUserStatusFailure(state) {
      state.loading = false;
    },
    logoutSuccess(state) {
      state.user = null;
      state.selectedAccountId = 0;
    },
    selectAccount(state, { accountId }) {
      state.selectedAccountId = accountId;
      localStorage.setItem('a-eye-selected-account-id', state.selectedAccountId);
    }
  },
  actions: {
    async introspect({ dispatch }) {
      const { data } = await axios.post(
        config('auth.introspectionUrl'),
        {
          client_id: config('auth.clientId'),
          client_secret: config('auth.clientSecret')
        },
        {
          withCredentials: true
        }
      );

      localStorage.setItem('produce-token', JSON.stringify(data));
      return dispatch('fetchUserStatus');
    },
    async preloadUserStatus({ commit }) {
      commit('preloadUserStatusPending');
      try {
        const user = await getUser();
        if (user && user.roles.length == 0) {
          window.location = window.config('auth.profileUrl').replace('/profile', '');
          return;
        }
        commit('preloadUserStatusSuccess', { user: user });
      } catch (err) {
        commit('preloadUserStatusFailure');
        throw err;
      }
    },
    async fetchUserStatus({ commit }) {
      commit('fetchUserStatusPending');
      try {
        const user = await getUser();
        commit('fetchUserStatusSuccess', { user: user });
        return user;
      } catch (err) {
        commit('fetchUserStatusFailure');
        throw err;
      }
    },
    async fetchUserProducts({ commit }) {
      try {
        const products = await listProducts();
        commit('fetchUserProductsSuccess', { products });
      } catch (err) {
        console.error('Server error when getting uploads', err);
      }
    },
    logout({ commit }) {
      localStorage.removeItem('produce-token');
      commit('logoutSuccess');
    }
  },
  getters: {}
};
